// We only need this JS to prevent the nav jump links from adding a hash to the URL.
// Note: We’re avoiding preventDefault() in order to take advantage of native smooth scrolling.

class ExplainerDesktopNav {
  constructor(el) {
    this.el = el;
    this.modalContent = document.querySelector(".Explainer-content");
    this.explainerSlides = document.querySelectorAll(".Explainer-slide");

    // Breakpoint at which to init JS (must match $layout-explainer-wide-bp in _layout-vars.scss)
    this.mediaQueryList = window.matchMedia("(min-width: 900px)");

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.init();
      }
    });

    // Init on load
    if (this.mediaQueryList.matches) {
      this.init();
    }
  }

  init() {
    this.el.addEventListener("click", evt => {
      evt.preventDefault();// stops hash from begin added to URL, but also prevents scroll
      this.updateSlides(evt.currentTarget.hash);
    });
  }

  updateSlides(activeHash) {
    let activeId = activeHash.replace("#", "");
    // We need to know once the active slide was found during
    // the loop so we can stop applying the “is-stuck” class.
    let foundActive = false;

    this.explainerSlides.forEach(slide => {
      if (!foundActive) {
        slide.classList.add("is-stuck");

        if (slide.id == activeId) {
          foundActive = true;

          // Scroll to active slide
          this.modalContent.scrollTop = slide.offsetTop;
        }
      } else {
        slide.classList.remove("is-stuck");
      }
    });
  }
}

// Init
document.querySelectorAll('.ExplainerNavDesktop-link').forEach(el => new ExplainerDesktopNav(el));
